import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { Cell } from 'fixed-data-table-2';

import NoDataCell from '../NoDataCell';

import config from '../../../../../config';

import client from '../../../../../client';

class FileCell extends Component {
    state = {
        showMore: false,
        tooltipPosition: {
            top: 0,
            left: 0
        }
    };

    moreButtonRef = React.createRef();

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }

    handleOutsideClick = (e) => {
        if (
            this.state.showMore &&
            this.moreButtonRef.current &&
            !this.moreButtonRef.current.contains(e.target)
        ) {
            const tooltip = document.getElementById(
                `file-tooltip-${this.props.rowIndex}`
            );

            if (tooltip && tooltip.contains(e.target)) {
                return;
            }

            this.setState({
                showMore: false
            });
        }
    };

    openSingleLink = (file) => {
        if (!file) return;

        if (
            typeof file === 'string' &&
            file.startsWith('protected/')
        ) {
            client()
                .get(`${config.playerApi}/${file}`)
                .then(res => {
                    window.open(res.data, '_blank');
                })
                .catch(e => {
                    console.log(e);
                });
        } else {
            let fileUrl =
                file && !file.startsWith('http')
                    ? config.assetsBasePath + file
                    : file;

            // Remove duplicate slashes
            fileUrl = fileUrl.replace(/([^:]\/)\/+/g, '$1');

            window.open(fileUrl, '_blank');
        }
    };

    getFileName = (file) => {
        if (!file) return '';

        // Remove query string
        const cleanFile = file.split('?')[0];

        // Get only the file name
        return cleanFile.substring(
            cleanFile.lastIndexOf('/') + 1
        );
    };

    toggleMore = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!this.moreButtonRef.current) {
            return;
        }

        const rect =
            this.moreButtonRef.current.getBoundingClientRect();

        this.setState(prevState => ({
            showMore: !prevState.showMore,
            tooltipPosition: {
                top: rect.bottom + 5,
                left: rect.left
            }
        }));
    };

    renderFileLink = (file, index) => {
        const fileName = this.getFileName(file);

        return (
            <a
                key={index}
                href="#"
                title={fileName}
                style={{
                    color: '#007bff',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    display: 'block',
                    padding: '4px 0',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.openSingleLink(file);
                }}
            >
                {fileName}
            </a>
        );
    };

    renderTooltip = (files) => {
        const {
            showMore,
            tooltipPosition
        } = this.state;

        if (!showMore || files.length <= 1) {
            return null;
        }

        const tooltip = (
            <div
                id={`file-tooltip-${this.props.rowIndex}`}
                style={{
                    position: 'fixed',
                    top: tooltipPosition.top,
                    left: tooltipPosition.left,
                    zIndex: 999999,

                    width: '350px',
                    maxWidth: '350px',
                    maxHeight: '250px',

                    overflowY: 'auto',

                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: '4px',

                    padding: '8px 12px',

                    boxShadow:
                        '0 4px 12px rgba(0, 0, 0, 0.25)',

                    fontSize: '14px',

                    boxSizing: 'border-box'
                }}
                onMouseDown={(e) => {
                    e.stopPropagation();
                }}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                {/* Tooltip arrow */}
                <div
                    style={{
                        position: 'absolute',
                        top: '-6px',
                        left: '15px',
                        width: '10px',
                        height: '10px',
                        backgroundColor: '#fff',
                        borderLeft: '1px solid #ccc',
                        borderTop: '1px solid #ccc',
                        transform: 'rotate(45deg)'
                    }}
                />

                {files.slice(1).map((file, index) => (
                    <div
                        key={index}
                        style={{
                            borderBottom:
                                index < files.length - 2
                                    ? '1px solid #eee'
                                    : 'none'
                        }}
                    >
                        {this.renderFileLink(
                            file,
                            index + 1
                        )}
                    </div>
                ))}
            </div>
        );

        return ReactDOM.createPortal(
            tooltip,
            document.body
        );
    };

    render() {
        const {
            rows,
            columnKey,
            rowIndex,
            width
        } = this.props;

        const valueToRender =
            rows.getObjectAt(rowIndex)[columnKey];

        let cellAlignment;
        let cellStyle;

        if (config && config.styles) {
            const styles = config.styles;

            cellAlignment =
                styles.alignment &&
                styles.alignment.value;

            cellStyle = {
                color: styles.color,
                textDecoration: styles.lineThrough
                    ? 'line-through'
                    : 'inherit'
            };
        }

        if (
            !valueToRender ||
            (
                Array.isArray(valueToRender) &&
                valueToRender.length === 0
            )
        ) {
            return <NoDataCell {...this.props} />;
        }

        const files = Array.isArray(valueToRender)
            ? valueToRender
            : [valueToRender];

        const { showMore } = this.state;

        return (
            <>
                <Cell
                    width={width}
                    align={cellAlignment || 'left'}
                    style={cellStyle}
                >
                    <div
                        style={{
                            minWidth: 0
                        }}
                    >
                        {/* First file */}
                        <div
                            style={{
                                minWidth: 0,
                                maxWidth: '100%'
                            }}
                        >
                            {this.renderFileLink(files[0], 0)}
                        </div>

                        {/* More / Less button on next line */}
                        {files.length > 1 && (
                            <button
                                ref={this.moreButtonRef}
                                type="button"
                                onClick={this.toggleMore}
                                style={{
                                    display: 'block',
                                    border: 'none',
                                    background: 'none',
                                    padding: 0,
                                    marginTop: '-5px',

                                    color: '#007bff',
                                    cursor: 'pointer',

                                    fontSize: '14px',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {showMore ? 'Less' : 'More'}
                            </button>
                        )}
                    </div>
                </Cell>

                {/* Render tooltip outside fixed-data-table */}
                {this.renderTooltip(files)}
            </>
        );
    }
}

export default FileCell;